module.exports = __webpack_public_path__ + "img/1.0da344c5.jpg";